import React from "react";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import VisitaGrupo1 from "../components/quizz/VisitaGrupo1";
import VisitaGrupo2 from "../components/quizz/VisitaGrupo2";
import VisitaGrupo3 from "../components/quizz/VisitaGrupo3";
import VisitaGrupo4 from "../components/quizz/VisitaGrupo4";
import Swal from "sweetalert2";

class Quizzes extends React.Component {
  initialState = {
    cat_tipo_establecimiento: Api.loadCatalogue("cat_tipo_establecimiento"),
    cat_establecimientos_alimento: [],
    cat_establecimientos_fabricante_alimento: [],
    sales_texto: "",
    municipios: [],
    nivelUsuario: localStorage.nivel_actual,
    tipo_categoria_especie: "",
    otros_texto: "",
    variables_dinamicas: [],
    otro_motivo_remision: false,
    otro_motivo_remision_texto: "",
    no_lote: "",
    vol_peso: "",
    loadedObsInfo: false,
    displayAcc: false,
    total_analisis_solicitado: 0,
    materia_prima_texto: "",
    unidad_medida_vol: "",
    cat_um: [], //um = unidad medida
    cat_motivo_remision: [],
    tipo_establecimiento: null,
    ultima_fecha_inspeccion: null,
    nombre_comercial: "",
    observaciones_anteriores: null,
    recomendaciones_anteriores: null,
    modalState: false,
    tipo_motivo_remision: [],
    info_encuesta: "",
    establecimiento_registrado: true,
    establecimiento_fabricante_registrado: true,
    quizzes: [],
    questions: [],
    recomendaciones: "",
    observaciones: "",
    producto_tipo_alimento_texto: "",
    producto_tipo_alimento: "",
    razon_social: "",
    razon_social_muestra: "",
    no_licencia_disaan: null,
    direccion: "",
    longitud: "",
    latitud: "",
    apartado_postal: null,
    codigo_registro: null,
    analisis_resultado: [],
    representantes_legales: [],
    nombre_representante: "",
    nombre_recibe_laboratorio: "",
    regentes: [],
    telefono: null,
    correo_electronico: null,
    lugar: null,
    nombre_receptor: null,
    cargo_receptor: null,
    fecha_inspeccion: new Date().toISOString().slice(0, 10),
    fecha: new Date().toISOString().slice(0, 10),
    correo_electronico_regente: null,
    cat_tipo_produccion: Api.loadCatalogue("cat_tipo_produccion"),
    cat_tipo_inspeccion: Api.loadCatalogue("cat_tipo_inspeccion"),
    cat_especies: Api.loadCatalogue("cat_especie"),
    tipo_inspeccion: null,
    destino_produccion: [],
    tipo_especie: [],
    locations: Api.loadCatalogue("locations"),
    establecimiento_sancionado: false,
    cat_materia_prima: Api.loadCatalogue("cat_materia_prima"),
    cat_paises: Api.loadCatalogue("countries"),
    pais_id: "",
    materia_prima: [],
    volumen_mensual: null,
    establecimiento_id: "",
    establecimiento_id_muestra: "",
    volumen_semanal: null,
    producto: "",
    presentacion_producto: "",
    cantidad_producto: "",
    motivo_acto: "",
    no_registro: "",
    num_acta_decomiso: "",
    cat_productos: [],
    nombres_analisis_duplicados: [],
    folio_manual: null,
    cat_presentacion_producto: [],
    folio_establecimiento: null,
    porc_exp_nica: null,
    cat_tipo_subproducto: Api.loadCatalogue("cat_tipo_subproducto"),
    tipo_subproducto: [],
    forma_farmaceutica_id: "",
    forma_farmaceutica: null,
    forma_farmaceutica_texto: "",
    cat_forma_farmaceutica: [],
    fecha_vencimiento: null,
    propietario: null,
    num_regente: null,
    regente_presente: null,
    regente_vigente: null,
    hora_atencion_inicio: "",
    hora_inicio: null,
    hora_fin: null,
    hora_atencion_final: "",
    verificaciones: {},
    ultima_verificacion: [],
    establecimiento_muestra_registrado: true,
    fecha_sat: null,
    inspectores: [],
    visita_tipo_muestra: [],
    cat_inspectores: [],
    cat_categorias: [],
    regente: null,
    tipo_encuesta: null,
    actividad_id: "",
    municipio_id: null,
    establecimientos: [],
    producto_fabricante_registrado: true,
    locacion_analisis_nacional: true,
    regentesV: [],
    tipo_muestra: "",
    cat_tipo_muestra: "",
    departamento_id: null,
    nombreDepartamento: null,
    cat_especies_productos_dosis: [],
    nombreMunicipio: null,
    nombrePais: null,
    reg_producto_manual: false,
    cat_actividades: [],
    licencia_establecimiento: "",
    producto_detalle_acta: {
      producto_id: "",
      nombre_comercial: "",
      presentacion_id: "",
      presentacion: "",
      cantidad: "",
      motivo_acto: "",
    },
    producto_detalle_acta_destruccion: {
      num_acta_decomiso: "",
      motivo_acto: "",
    },
    productos_detalle_acta: [],
    cat_productos_tipo_alimento: [],
    cat_analisis_solicitado: [],
    cat_analisis_producto: [],
    elemento_muestra_id: null,
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  componentDidMount() {
    // si el usuario no es nivel inspector redireccionamos a home
    if (this.state.nivelUsuario !== "5") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getQuizzes",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [15, 5, 10, 20],
      progressText: "Cargando datos",
      rows: {
        id: {
          label: "ID",
        },
        descripcion: {
          label: "Encuesta",
        },
        status: {
          label: "Estado",
          render: (me) => {
            if (me.data.status === "1") {
              me.innerHTML = "Activo";
            } else {
              me.innerHTML = "Inactivo";
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-list",
          btnClass: "btn bg-gradient-green",
          btnClick: (data) => {
            Api.loading(true);
            let ruta = "";
            ruta = "app/getQuizz?tipo_encuesta_id=" + data.id;

            this.setState({
              tipo_encuesta: data.id,
              hora_inicio:
                new Date().getHours() + ":" + new Date().getMinutes(),
            });
            this.loadEstablecimientos(data.id);
            this.getInspectors();
            this.getCatProductos();

            if (data.id === "8" || data.id === "9" || data.id === "10") {
              this.getAllProductosTipoAlimento();
              this.getAllEstablecimientosAlimento();
              this.getAllEstablecimientosFabricanteAlimento();

              this.setState({
                cat_motivo_remision: Api.loadCatalogue("cat_motivo_remision"),
                cat_um: Api.loadCatalogue("cat_unidad_medida"),
                cat_tipo_muestra: Api.loadCatalogue("cat_tipo_muestra"),
                cat_analisis_producto: Api.loadCatalogue(
                  "cat_analisis_producto"
                ),
                cat_forma_farmaceutica: Api.loadCatalogue(
                  "cat_forma_farmaceutica"
                ),
                unidad_medida_vol: 3,
                analisis_resultado: [],
                visita_tipo_muestra: [],
              });

              if (data.id === "9" || data.id === "10") {
                this.getCatAnalisisResultado(data.id);
              }
            }

            Api.fetch(ruta)
              .then((encuestas) => {
                this.setEnecuesta(encuestas, data);
              })
              .then(() => {
                Api.loading(false);
              });
          },
          render: (me, data) => {
            if (data.status !== "1") {
              me.remove();
            }
          },
        },
      ],
    };

    let mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      onchange: (me, data, serial) => {
        mi_grid.go(1, serial);
      },

      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "descripcion",
            label: "Buscar encuesta",
            placeholder: "Escribir nombre de la encuesta",
            cols: 12,
            value: "",
          },
        },
      ],
    });
  }

  setEnecuesta = (encuestas, data) => {
    if (["1", "2", "3", "11", "12", "13"].includes(this.state.tipo_encuesta)) {
      encuestas.verificaciones.forEach((d, i) => (d.last_obs_checked = false));
    }
    this.setState({
      info_encuesta: data,
      modalState: true,
      quizzes: encuestas.verificaciones,
      questions: encuestas.respuestas,
    });
  };

  loadEstablecimientos = (tipo_encuesta) => {
    Api.fetch("app/getAllEstablecimientos?tipo_encuesta=" + tipo_encuesta).then(
      (data) => {
        if (data) {
          this.setState({ establecimientos: data });
        }
      }
    );
  };

  getAllEstablecimientosFabricanteAlimento = () => {
    Api.fetch("app/getAllEstablecimientosFabricanteAlimento").then((data) => {
      if (data) {
        this.setState({ cat_establecimientos_fabricante_alimento: data });
      }
    });
  };

  getAllEstablecimientosAlimento = () => {
    Api.fetch("app/getAllEstablecimientosAlimento").then((data) => {
      if (data) {
        this.setState({ cat_establecimientos_alimento: data });
      }
    });
  };

  loadRegentes(id) {
    Api.fetch("app/getEstablishmentRegents?establecimiento_id=" + id).then(
      (data) => {
        if (data) {
          this.setState({ regentesV: data });
        }
      }
    );
  }

  setDepartamento = (id) => {
    let result = this.state.locations.departamentos.find(
      (departamento) => departamento.id === parseInt(id)
    );

    if (id) {
      this.setState({
        departamento_id: result.id,
        nombreDepartamento: result.name.toUpperCase(),
      });
    } else {
      this.setState({
        departamento_id: null,
        nombreDepartamento: null,
      });
    }
  };

  setMunicipio = (id) => {
    let result = this.state.locations.municipios.find(
      (municipio) => municipio.id === parseInt(id)
    );

    if (id) {
      this.setState({
        municipio_id: result.id,
        nombreMunicipio: result.name.toUpperCase(),
      });
    } else {
      this.setState({
        municipio_id: null,
        nombreMunicipio: null,
      });
    }
  };

  getCatProductos = () => {
    Api.fetch("app/getCatProductos").then((data) => {
      if (data) {
        this.setState({ cat_productos: data });
      }
    });
  };

  getAllProductosTipoAlimento = () => {
    Api.fetch("app/getAllProductosTipoAlimento").then((data) => {
      if (data) {
        this.setState({ cat_productos_tipo_alimento: data });
      }
    });
  };

  handleActividadMuestra = (e) => {
    this.cleanErrorsValidation("actividad_id");
    this.setState({ actividad_id: e.target.value });
  };

  handleFormCloseBtn = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "¿Seguro que quiere cerrar el formulario?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#4CD964",
      denyButtonColor: "red",
      denyButtonText: "Cancelar",
      confirmButtonText: "Aceptar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.resetStates();
      }
    });
  };

  handleRazonSocialTextoChange = (e) => {
    this.cleanErrorsValidation("razon_social");
    this.setState({ razon_social: e.target.value.toUpperCase() });
  };

  handleRazonSocialMuestraTextoChange = (e) => {
    this.cleanErrorsValidation("razon_social_muestra");
    this.setState({
      razon_social_muestra: e.target.value.toUpperCase(),
    });
  };

  getProductPresentation = (producto_id) => {
    Api.loading(true);
    Api.fetch("app/getProductPresentation?producto_id=" + producto_id)
      .then((data) => {
        if (data) {
          this.setState({ cat_presentacion_producto: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  addProductoDetalle = (e) => {
    this.cleanErrorsValidation("productos_detalle_acta");

    let prodDA = { ...this.state.producto_detalle_acta };
    let prodsDA = [...this.state.productos_detalle_acta];
    if (
      prodDA.nombre_comercial !== "" &&
      prodDA.presentacion !== "" &&
      prodDA.cantidad !== "" &&
      prodDA.motivo_acto !== ""
    ) {
      for (let p in prodsDA) {
        if (
          prodsDA[p].nombre_comercial === prodDA.nombre_comercial &&
          prodsDA[p].presentacion === prodDA.presentacion
        ) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este producto en su lista.",
          });
          return false;
        }
      }

      prodsDA.push(prodDA);

      this.setState({
        productos_detalle_acta: prodsDA,
        producto: this.initialState.producto,
        producto_detalle_acta: this.initialState.producto_detalle_acta,
        presentacion_producto: this.initialState.presentacion_producto,
        cantidad_producto: this.initialState.cantidad_producto,
        motivo_acto: this.initialState.motivo_acto,
      });
    } else {
      this.fireSwal(
        "Debe completar los datos obligatorios para poder agregar un producto a la lista",
        "warning"
      );
    }
  };

  addOtroAnalisis = (e) => {
    let table = document.getElementById("tabla_otros_body"),
      rowCount = table.rows.length,
      row = table.insertRow(rowCount),
      secuencial = this.state.total_analisis_solicitado + 1;

    this.setState({ total_analisis_solicitado: secuencial });

    // insertamos input para ingresar el nombre del análisis
    let cell1 = row.insertCell(0),
      element1 = document.createElement("input");
    element1.type = "text";
    element1.name = `analisis_producto_nombre_otro-${secuencial}`;
    element1.id = `analisis_producto_nombre_otro-${secuencial}`;
    element1.className = "form-control";
    element1.setAttribute("required", true);
    element1.placeholder = "Análisis solicitado";
    element1.oninput = (e) => this.handleAnalisisSolicitadoChange(e);
    cell1.appendChild(element1);

    // input para especificar
    let cell2 = row.insertCell(1),
      element2 = document.createElement("input");
    element2.type = "text";
    element2.setAttribute("readonly", true);
    element2.name = `analisis_producto_input_otro-${secuencial}`;
    element2.id = `analisis_producto_input_otro-${secuencial}`;
    element2.className = "form-control";
    element2.placeholder = "Especificar";
    element2.onkeyup = (e) => this.handleAnalisisSolicitadoChange(e);
    cell2.appendChild(element2);

    // botón para eliminar row
    let cell3 = row.insertCell(2),
      element3 = document.createElement("button"),
      span = document.createElement("span");
    element3.id = `${secuencial}-${rowCount}`;
    element3.type = "button";
    element3.className = "btn btn-danger float-right";
    element3.title = "Remover";
    span.className = "far fa-trash-alt";
    span.id = `${secuencial}-${rowCount}`;
    element3.appendChild(span);
    element3.onclick = (e) => this.removeOtroAnalisis(e);
    cell3.appendChild(element3);
  };

  addProdActaDestruccion = (e) => {
    this.cleanErrorsValidation("productos_detalle_acta");
    let prodDA = { ...this.state.producto_detalle_acta_destruccion };
    let prodsDA = [...this.state.productos_detalle_acta];

    if (prodDA.num_acta_decomiso !== "" && prodDA.motivo_acto !== "") {
      for (let p in prodsDA) {
        if (prodsDA[p].num_acta_decomiso === prodDA.num_acta_decomiso) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este número acta en su lista.",
          });
          return false;
        }
      }

      prodsDA.push(prodDA);

      this.setState({
        productos_detalle_acta: prodsDA,
        producto_detalle_acta_destruccion:
          this.initialState.producto_detalle_acta_destruccion,
        motivo_acto: this.initialState.motivo_acto,
        num_acta_decomiso: this.initialState.num_acta_decomiso,
      });
    } else {
      this.fireSwal(
        "Debe completar los datos obligatorios para poder agregar un producto a la lista",
        "warning"
      );
    }
  };

  removeOtroAnalisis = (e) => {
    let table = document.getElementById("tabla_otros_body"),
      ids = e.target.id.split("-"),
      objKey = null,
      nombres_analisis_duplicados = this.state.nombres_analisis_duplicados,
      analisis_resultado = this.state.analisis_resultado;

    // let row = table.rows[parseInt(ids[1])];
    let row = document.getElementById(e.target.id).closest("tr").rowIndex - 1;
    table.deleteRow(row);

    objKey = this.getAnalisisOtrosObjectItem(ids[0]);

    //eliminamos el objeto que coincida con el id del elemento
    nombres_analisis_duplicados = nombres_analisis_duplicados.filter(function (
      obj
    ) {
      return obj.id !== e.target.id;
    });

    this.setState({
      nombres_analisis_duplicados: nombres_analisis_duplicados,
    });

    if (analisis_resultado[objKey]) {
      delete analisis_resultado[objKey];
      analisis_resultado = this.resetAnalisisObjectIndexes();
      this.setState({ analisis_resultado: analisis_resultado });
    }
  };

  removeProductoDetalle = (e) => {
    let prodsDA = [...this.state.productos_detalle_acta];
    prodsDA.splice(e.target.id, 1);
    this.setState({ productos_detalle_acta: prodsDA });
  };

  setPais = (pais_id, pais_texto) => {
    if (pais_id != null) {
      this.setState({ nombrePais: pais_texto, pais_id: pais_id });
    } else {
      this.setState({ nombrePais: "", pais_id: "" });
    }
  };

  getRepresentantesLegales = (id) => {
    if (id != null) {
      if (["8", "9", "10"].includes(this.state.tipo_encuesta)) {
        Api.loading(true);
      }

      Api.fetch("app/getRepresentantesLegales?establecimiento_id=" + id)
        .then((data) => {
          if (data) {
            this.setState({ representantes_legales: data });
          }
        })
        .then((res) => Api.loading(false));
    }
  };

  getRegentes = (id) => {
    if (id != null) {
      if (["8", "9", "10"].includes(this.state.tipo_encuesta)) {
        Api.loading(true);
      }

      Api.fetch("app/getRegentesEstablecimiento?establecimiento_id=" + id)
        .then((data) => {
          if (data) {
            this.setState({ regentes: data });
          }
        })
        .then((res) => {
          if (["8", "9", "10"].includes(this.state.tipo_encuesta)) {
            Api.loading(false);
          }
        });
    }
  };

  resetVerifications = () => {
    let verificaciones_anteriores = [...this.state.quizzes];
    for (const key in verificaciones_anteriores) {
      verificaciones_anteriores[key]["verificaciones"].forEach((o) => {
        o["ultima_observacion"] = null;
      });
    }
    this.setState({ quizzes: verificaciones_anteriores });
  };

  getLicenciaEstablecimiento(establecimiento_id) {
    if (establecimiento_id != null) {
      Api.fetch(
        "app/getLicenciaActividad?establecimiento_id=" +
          establecimiento_id +
          "&tipo_encuesta=" +
          this.state.tipo_encuesta
      ).then((data) => {
        if (data) {
          this.setState({ cat_actividades: data });
        }
      });
    }
  }

  handleSelectClasifEncuestaChange = (e) => {
    const value = e.target.value,
      name = e.target.name;

    let idName = "ver-" + name.split("-")[1],
      respuesta = null;

    // if (e.target.value) {
    //   document
    //     .getElementById(`observacion-${name.split("-")[1]}`)
    //     .removeAttribute("disabled");
    // }

    this.makeRequiredFields(e.target.id.split("-")[1]);

    !["13"].includes(this.state.tipo_encuesta)
      ? (respuesta = null)
      : (respuesta = 0);

    if (!this.state.verificaciones.hasOwnProperty(idName)) {
      this.setState({
        verificaciones: {
          ...this.state.verificaciones,
          [idName]: {
            ...this.state.verificaciones[idName],
            ...{
              id: idName.split("-")[1],
              valor: value,
              observacion: null,
              respuesta: respuesta,
            },
          },
        },
      });
    } else {
      this.setState({
        verificaciones: {
          ...this.state.verificaciones,
          [idName]: {
            ...this.state.verificaciones[idName],
            ...{ id: idName.split("-")[1], valor: value },
          },
        },
      });
    }
  };

  makeRequiredFields = (id) => {
    document
      .getElementById(`verificacion-${id}`)
      .setAttribute("required", true);
    // document.getElementById(`observacion-${id}`).setAttribute("required", true);
  };

  getVisitaDetalle = (verificacion_id, jsonKeys) => {
    let variables_dinamicas = this.state.variables_dinamicas;

    Api.fetch(
      "app/getSpecificVerificationObsInfo?verificacion_id=" +
        verificacion_id +
        "&tipo_encuesta_id=" +
        this.state.tipo_encuesta +
        "&actividad_id=" +
        this.state.actividad_id +
        "&establecimiento_id=" +
        this.state.establecimiento_id +
        "&ids=" +
        jsonKeys
    )
      .then((data) => {
        if (Object.keys(data).length > 0) {
          data.forEach((d, i) => {
            if (variables_dinamicas.hasOwnProperty(`acc-${verificacion_id}`)) {
              d
                ? (variables_dinamicas[`acc-${verificacion_id}`][i][
                    "ultima_observacion"
                  ] = d.observacion)
                : (variables_dinamicas[`acc-${verificacion_id}`][i][
                    "ultima_observacion"
                  ] = null);
            }
          });
        }

        // se pone estatus true que significa última observavacion verificada para que no la vuelva a buscar mientras tenga los mismos parametros de busqueda
        this.state.quizzes.filter((obj) => {
          if (obj.id === verificacion_id) {
            obj.last_obs_checked = true;
          }

          return false;
        });
      })
      .then((res) => {
        this.setState({
          variables_dinamicas: variables_dinamicas,
          quizzes: this.state.quizzes,
          loadedObsInfo: true,
        });
      });
  };

  getSpecificVerification = (verificacion) => {
    let variables_dinamicas = this.state.variables_dinamicas;

    if (this.state.actividad_id) {
      if (!verificacion.last_obs_checked) {
        this.setState({
          loadedObsInfo: this.initialState.loadedObsInfo,
        });

        Api.loading(true);
        Api.fetch("app/getSpecificVerificationInfo?id=" + verificacion.id)
          .then((data) => {
            if (data) {
              variables_dinamicas[`acc-${verificacion.id}`] = data;

              let ids = data.map((d) => d.id);

              if (
                this.state.establecimiento_registrado &&
                this.state.actividad_id !== this.state.actividadPrevia
              ) {
                let objKeys = encodeURIComponent(JSON.stringify(ids));

                this.getVisitaDetalle(verificacion.id, objKeys);
              } else {
                this.setState({ loadedObsInfo: true });
              }
              this.setState({
                variables_dinamicas: variables_dinamicas,
                quizzes: this.state.quizzes,
              });
            }
          })
          .then((res) => Api.loading(false));
      }
    } else {
      this.fireSwal(
        "Debe tener seleccionada una actividad del establecimiento para poder desplegar el cuestionario.",
        "info"
      );
    }
  };

  handleCheckEncuestaChange = (e) => {
    // const value = e.target.checked,
    let name = e.target.name;

    let idName = "ver-" + name.split("-")[1],
      respuesta = 0;

    // if (this.state.tipo_encuesta === "13" && e.target.checked === true) {
    //   document
    //     .getElementById(`verificacion-${name.split("-")[1]}`)
    //     .setAttribute("required", true);
    // }

    if (e.target.checked === true) {
      respuesta = 1;
    }

    if (!this.state.verificaciones.hasOwnProperty(idName)) {
      this.setState({
        verificaciones: {
          ...this.state.verificaciones,
          [idName]: {
            ...this.state.verificaciones[idName],
            ...{
              id: idName.split("-")[1],
              valor: null,
              observacion: null,
              respuesta: respuesta,
            },
          },
        },
      });
    } else {
      this.setState({
        verificaciones: {
          ...this.state.verificaciones,
          [idName]: {
            ...this.state.verificaciones[idName],
            ...{ id: idName.split("-")[1], respuesta: respuesta },
          },
        },
      });
    }
  };

  handleRadioEncuestaChange = (e) => {
    const value = e.target.value,
      name = e.target.name;
    let idName = null,
      respuesta = null;

    if (value === "2") {
      document.getElementById(
        "observacion-" + name.split("-")[1]
      ).required = true;
    } else {
      document.getElementById(
        "observacion-" + name.split("-")[1]
      ).required = false;
    }

    idName = "ver-" + name.split("-")[1];

    ["1", "2", "3"].includes(this.state.tipo_encuesta)
      ? (respuesta = null)
      : (respuesta = 0);

    if (!this.state.verificaciones.hasOwnProperty(idName)) {
      this.setState({
        verificaciones: {
          ...this.state.verificaciones,
          [idName]: {
            ...this.state.verificaciones[idName],
            ...{
              id: idName.split("-")[1],
              valor: value,
              observacion: null,
              respuesta: respuesta,
            },
          },
        },
      });
    } else {
      this.setState({
        verificaciones: {
          ...this.state.verificaciones,
          [idName]: {
            ...this.state.verificaciones[idName],
            ...{ id: idName.split("-")[1], valor: value },
          },
        },
      });
    }
  };

  handleTextAreaEncuestaChange = (e) => {
    // this.makeRequiredFields(e.target.id.split("-")[1]);

    const value = e.target.value.toUpperCase(),
      name = e.target.name;

    let respuesta = null;

    let idName = "ver-" + name.split("-")[1];

    ["1", "2", "3"].includes(this.state.tipo_encuesta)
      ? (respuesta = null)
      : (respuesta = 0);

    document.getElementById(e.target.id).value = value;

    if (!this.state.verificaciones.hasOwnProperty(idName)) {
      this.setState({
        verificaciones: {
          ...this.state.verificaciones,
          [idName]: {
            ...this.state.verificaciones[idName],
            ...{
              id: idName.split("-")[1],
              valor: null,
              observacion: value,
              respuesta: respuesta,
            },
          },
        },
      });
    } else {
      this.setState({
        verificaciones: {
          ...this.state.verificaciones,
          [idName]: {
            ...this.state.verificaciones[idName],
            ...{ id: idName.split("-")[1], observacion: value },
          },
        },
      });
    }
  };

  cleanErrorsValidation = (elemento) => {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (classInvalid.classList.contains("is-invalid") && divError) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  };

  cleanErrorsValidation = (elemento) => {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  };

  handleValidations = (errors) => {
    for (const i in errors) {
      document.getElementById(i + "-error").style.display = "block";
      document.getElementById(i + "-error").innerText = errors[i];
      document.getElementById(i).classList.add("is-invalid");
    }
  };

  fireSwal(title, icon = "error") {
    Swal.fire({
      title: title,
      icon: icon,
      timer: 3000,
    });
    return false;
  }

  handleRazonSocialChange = (e) => {
    let est_id = e.target.value;
    Api.loading(true);
    Api.fetch("app/getEstablecimiento?id=" + est_id)
      .then((data) => {
        if (data) {
          this.setState({
            razon_social: data.razon_social,
            establecimiento_id: est_id,
            observaciones_anteriores:
              this.initialState.observaciones_anteriores,
            recomendaciones_anteriores:
              this.initialState.recomendaciones_anteriores,
            ultima_fecha_inspeccion: this.initialState.ultima_fecha_inspeccion,
            tipo_establecimiento: data.tipo_establecimiento_id,
            displayAcc: this.initialState.displayAcc,
            establecimiento_sancionado:
              this.initialState.establecimiento_sancionado,
            loadedObsInfo: this.initialState.loadedObsInfo,
            representantes_legales: this.initialState.representantes_legales,
            regentes: this.initialState.regentes,
          });

          this.getRepresentantesLegales(est_id);
          this.getRegentes(est_id);

          if (["1", "2", "3", "11", "12"].includes(this.state.tipo_encuesta)) {
            this.resetVerifications();
          }

          this.handleCorreoElectronico(data.correo_electronico);
          this.setPais(data.pais_id, data.pais_texto);
          this.handleLatitudChange(data.latitud);
          this.handleLongitudChange(data.longitud);
          this.handleTelefono(data.telefono);
          this.handleFolioEstablecimientoChange(data.folio_establecimiento);
          this.setDepartamento(data.departamento_id);
          this.setMunicipio(data.municipio_id);
          this.getLicenciaEstablecimiento(est_id);
          this.handleDireccionChange(data.direccion);
          this.cleanErrorsValidation("razon_social");
          this.cleanErrorsValidation("actividad_id");
          this.cleanErrorsValidation("licencia_establecimiento");

          if (
            this.state.tipo_encuesta === "4" ||
            this.state.tipo_encuesta === "5" ||
            this.state.tipo_encuesta === "7"
          ) {
            this.setState({
              producto: this.initialState.producto,
              presentacion_producto: this.initialState.presentacion_producto,
              cat_presentacion_producto:
                this.initialState.cat_presentacion_producto,
              cantidad_producto: this.initialState.cantidad_producto,
              motivo_acto: this.initialState.motivo_acto,
            });
          }
        }
        if (["3", "11", "12", "13"].includes(this.state.tipo_encuesta)) {
          this.setState({
            regentesV: [],
            no_licencia_disaan: null,
            regente: null,
            correo_electronico_regente: null,
            num_regente: null,
            fecha_vencimiento: null,
          });
          this.loadRegentes(est_id);
        }

        if (
          data.tipo_establecimiento_id === "2" ||
          data.tipo_establecimiento_id === "4"
        ) {
          this.cleanErrorsValidation("nombrePais");
          this.setState({ nombrePais: data.pais_texto });
        }

        if (this.state.tipo_encuesta === "13") {
          this.limpiarLastObsChecked();
          this.limpiarUltimasObs();
          document.getElementById("actividad_id").removeAttribute("disabled");

          this.setState({
            verificaciones: this.initialState.verificaciones,
            displayAcc: this.initialState.displayAcc,
          });
        }
      })
      .then(function () {
        setTimeout(() => {
          Api.loading(false);
        }, 3000);
      });
  };

  handleRazonSocialFabricanteChange = (e) => {
    let establecimientoID = e.target.value,
      razonSocialTexto = e.target.options[e.target.selectedIndex].text;

    this.setState({
      razon_social: razonSocialTexto,
      establecimiento_id: establecimientoID,
    });

    this.cleanErrorsValidation("razon_social");
  };

  handleRazonSocialMuestraChange = (e) => {
    let establecimientoID = e.target.value,
      razonSocialTexto = e.target.options[e.target.selectedIndex].text;

    Api.loading(true);
    Api.fetch("app/getEstablecimiento?id=" + establecimientoID)
      .then((data) => {
        if (data) {
          this.setState({
            razon_social_muestra: razonSocialTexto,
            establecimiento_id_muestra: establecimientoID,
            representantes_legales: this.initialState.representantes_legales,
            regentes: this.initialState.regentes,
            departamento_id: data.departamento_id,
            municipio_id: data.municipio_id,
            nombrePais: data.pais_texto,
          });

          this.handleCorreoElectronico(data.correo_electronico);
          this.setPais(data.pais_id, data.pais_texto);
          this.handleLatitudChange(data.latitud);
          this.handleLongitudChange(data.longitud);
          this.handleTelefono(data.telefono);
          this.handleFolioEstablecimientoChange(data.folio_establecimiento);
          // this.setDepartamento(data.departamento_id);
          // this.setMunicipio(data.municipio_id);
          this.getLicenciaEstablecimiento(establecimientoID);
          this.handleDireccionChange(data.direccion);
          this.getRepresentantesLegales(establecimientoID);
          this.getRegentes(establecimientoID);
        }
      })
      .then((res) => Api.loading(false));

    this.cleanErrorsValidation("razon_social_muestra");
  };

  handleRegenteVChange = (e) => {
    this.cleanErrorsValidation("regente");
    this.cleanErrorsValidation("correo_electronico_regente");
    this.cleanErrorsValidation("no_licencia_disaan");
    this.cleanErrorsValidation("fecha_vencimiento");
    this.cleanErrorsValidation("num_regente");
    this.setState({
      regente: e.target.value,
      no_licencia_disaan: e.target[e.target.selectedIndex].getAttribute(
        "data-folio_licencia"
      ),
      correo_electronico_regente: e.target[e.target.selectedIndex].getAttribute(
        "data-correo_electronico"
      ),
      num_regente:
        e.target[e.target.selectedIndex].getAttribute("data-folio_regente"),
      fecha_vencimiento: e.target[e.target.selectedIndex]
        .getAttribute("data-fecha_vencimiento")
        .substring(0, 10),
    });
  };

  handleFolioManualChange = (e) => {
    this.setState({ folio_manual: e.target.value.toUpperCase() });
  };

  handleNoLicenciaDISAANChange(e) {
    this.setState({ no_licencia_disaan: e.target.value });
  }

  handleDireccionChange = (e) => {
    this.cleanErrorsValidation("direccion");
    if (this.state.establecimiento_registrado) {
      this.setState({ direccion: e.toUpperCase() });
    } else {
      this.setState({ direccion: e.target.value.toUpperCase() });
    }
  };

  handleLatitudChange = (e) => {
    this.cleanErrorsValidation("latitud");
    if (this.state.establecimiento_registrado) {
      this.setState({ latitud: e });
    } else {
      this.setState({ latitud: e.target.value });
    }
  };

  handleLongitudChange = (e) => {
    this.cleanErrorsValidation("longitud");
    if (this.state.establecimiento_registrado) {
      this.setState({ longitud: e });
    } else {
      this.setState({ longitud: e.target.value });
    }
  };

  handleApartadoPostalChange = (e) => {
    this.setState({ apartado_postal: e.target.value });
  };

  handleRecomendacionesChange = (e) => {
    this.setState({ recomendaciones: e.target.value.toUpperCase() });
  };

  handleObservacionesChange = (e) => {
    this.setState({ observaciones: e.target.value.toUpperCase() });
  };

  handleCodigoRegistroChange = (e) => {
    this.setState({ codigo_registro: e.target.value });
  };

  handleRegenteChange = (e) => {
    this.setState({ regente: e.target.value });
  };

  handleTelefono = (e) => {
    this.cleanErrorsValidation("telefono");
    this.setState({ telefono: e });
  };

  handleTelefonoChange = (e) => {
    this.cleanErrorsValidation("telefono");
    this.setState({ telefono: e.target.value });
  };

  handleCorreoElectronico = (e) => {
    this.cleanErrorsValidation("correo_electronico");
    this.setState({ correo_electronico: e });
  };

  handleCorreoElectronicoChange = (e) => {
    this.cleanErrorsValidation("correo_electronico");
    this.setState({ correo_electronico: e.target.value });
  };

  handleNombreReceptorChange = (e) => {
    this.cleanErrorsValidation("nombre_receptor");
    this.setState({ nombre_receptor: e.target.value.toUpperCase() });
  };

  handleCargoReceptorChange = (e) => {
    this.cleanErrorsValidation("cargo_receptor");
    this.setState({ cargo_receptor: e.target.value.toUpperCase() });
  };

  handleFechaInspeccionChange = (e) => {
    this.setState({ fecha_inspeccion: e.target.value });
  };

  handleFechaChange = (e) => {
    this.setState({ fecha_inspeccion: e.target.value });
  };

  handleTipoInspeccionChange = (e) => {
    this.cleanErrorsValidation("tipo_inspeccion");
    this.setState({ tipo_inspeccion: e.target.value });
  };

  setVisitaTipoMuestra = () => {
    let visita_tipo_muestra = this.state.visita_tipo_muestra;
    if (this.state.materia_prima_texto) {
      visita_tipo_muestra = {
        valor: this.state.materia_prima_texto,
        tipo_muestra_id: this.state.tipo_muestra.id,
      };
    }

    if (this.state.sales_texto) {
      visita_tipo_muestra = {
        valor: this.state.sales_texto,
        tipo_muestra_id: this.state.tipo_muestra.id,
      };
    }

    if (this.state.otros_texto) {
      visita_tipo_muestra = {
        valor: this.state.otros_texto,
        tipo_muestra_id: this.state.tipo_muestra.id,
      };
    }

    this.setState({ visita_tipo_muestra: visita_tipo_muestra });
  };

  handleDestinoProduccionChange = (e) => {
    this.cleanErrorsValidation("destino_produccion");
    this.setState({ destino_produccion: e });
  };

  handleTipoEspecieChange = (e) => {
    this.cleanErrorsValidation("tipo_especie");

    // para desabilitar/habilitar el resto de opciones en caso de que se elija la opcion de "todas las opciones"
    let arreglOpciones = null;

    if (e) {
      const opcionTodas = e.some((el) => el.id === "1");

      let limpiarArr = null;

      if (e.length > 1 && e[0]["id"] === "1") {
        limpiarArr = e.filter(function (obj) {
          return obj.id !== "1";
        });
      } else {
        limpiarArr = e.filter(function (obj) {
          return obj.id === "1";
        });
      }

      if (opcionTodas) {
        this.setState({ tipo_especie: limpiarArr });
        arreglOpciones = limpiarArr;
      } else {
        this.setState({ tipo_especie: e });
        arreglOpciones = e;
      }

      if (["8", "9", "10"].includes(this.state.tipo_encuesta)) {
        // data para select de categorías:
        // al seleccionar una o varias opciones hacemos una consulta para traernos las categorias de cada una

        // primero formamos un arreglo con los ids de la opcion de especies seleccionadas
        let especiesSeleccionadas = [];
        arreglOpciones.forEach((item) => especiesSeleccionadas.push(item.id));

        // transformarmos el objecto a array
        especiesSeleccionadas = Object.values(especiesSeleccionadas);

        // pasamos ese arreglo a formato json para poder enviarlo por la url en el fetch de a función
        let json = JSON.stringify(especiesSeleccionadas);
        // al tener el array invocamos la función para hacer la consulta al servidor
        this.getCategoriaEspecies(json);
      }
    } else {
      this.setState({
        tipo_especie: e,
        tipo_categoria_especie: this.initialState.tipo_categoria_especie,
        cat_categorias: this.initialState.cat_categorias,
      });
    }
  };

  handleCategoriasEspecieChange = (e) => {
    this.cleanErrorsValidation("tipo_categoria_especie");
    this.setState({ tipo_categoria_especie: e });
  };

  handleSalTextoChange = (e) => {
    this.cleanErrorsValidation("sales_texto");
    this.setState({ sales_texto: e.target.value.toUpperCase() });
  };

  handleOtroTipoMuestraChange = (e) => {
    this.cleanErrorsValidation("otros_texto");
    this.setState({ otros_texto: e.target.value.toUpperCase() });
  };

  handleOtroMotivoRemisionChange = (e) => {
    this.cleanErrorsValidation("otro_motivo_remision_texto");
    this.setState({ otro_motivo_remision_texto: e.target.value.toUpperCase() });
  };

  handleTipoMotivoRemisionChange = (e) => {
    this.cleanErrorsValidation("tipo_motivo_remision");

    let otroMotivo = false;

    if (e) {
      otroMotivo = e.some((el) => el.id === "5");
      this.setState({
        tipo_motivo_remision: e,
      });
    } else {
      this.setState({
        tipo_motivo_remision: this.initialState.tipo_motivo_remision,
      });
    }

    otroMotivo
      ? this.setState({ otro_motivo_remision: true })
      : this.setState({
          otro_motivo_remision: this.initialState.otro_motivo_remision,
          otro_motivo_remision_texto:
            this.initialState.otro_motivo_remision_texto,
        });
  };

  handleTipoMuestraChange = (e) => {
    let elementoID = null;

    this.cleanErrorsValidation("tipo_muestra");

    this.setState({
      tipo_muestra: e,
    });

    if (this.state.elemento_muestra_id) {
      this.cleanErrorsValidation(this.state.elemento_muestra_id);
    }

    if (e.id === "1" && this.state.producto_fabricante_registrado) {
      elementoID = "producto_tipo_alimento";
    } else if (e.id === "1" && !this.state.producto_fabricante_registrado) {
      elementoID = "producto_tipo_alimento_texto";
    } else if (e.id === "2") {
      elementoID = "materia_prima_texto";
    } else if (e.id === "3") {
      elementoID = "sales_texto";
    } else if (e.id === "4") {
      elementoID = "otros_texto";
    } else {
      elementoID = null;
    }

    this.setState({
      elemento_muestra_id: elementoID,
      no_registro: this.initialState.no_registro,
      producto_tipo_alimento_texto:
        this.initialState.producto_tipo_alimento_texto,
      producto_tipo_alimento: this.initialState.producto_tipo_alimento,
      sales_texto: this.initialState.sales_texto,
      otros_texto: this.initialState.otros_texto,
      materia_prima_texto: this.initialState.materia_prima_texto,
      forma_farmaceutica_id: this.initialState.forma_farmaceutica_id,
      forma_farmaceutica_texto: this.initialState.forma_farmaceutica_texto,
      forma_farmaceutica: this.initialState.forma_farmaceutica,
      tipo_especie: this.initialState.tipo_especie,
      cat_categorias: this.initialState.cat_categorias,
      tipo_categoria_especie: this.initialState.tipo_categoria_especie,
      visita_tipo_muestra: this.initialState.visita_tipo_muestra,
      establecimiento_id: this.initialState.establecimiento_id,
      establecimiento_fabricante_registrado:
        this.initialState.establecimiento_fabricante_registrado,
    });

    if (this.state.producto_fabricante_registrado) {
      this.setState({
        cat_especies_productos_dosis:
          this.initialState.cat_especies_productos_dosis,
        representantes_legales: this.initialState.representantes_legales,
        regentes: this.initialState.regentes,
      });
    }
  };

  handleNoLoteChange = (e) => {
    // let regex = /^[a-zA-Z0-9]*$/;
    // if (e.target.value === "" || regex.test(e.target.value)) {
    this.cleanErrorsValidation("no_lote");
    this.setState({ no_lote: e.target.value.toUpperCase() });
    // }
  };

  handleVolPesoChange = (e) => {
    if (this.checkPositiveFloats(e.target.value)) {
      this.cleanErrorsValidation("vol_peso");
      this.setState({ vol_peso: e.target.value });
    }
  };

  // funcion para validar solo enteros positivos en un input
  checkPositiveFloats = (str) => {
    let regex = /^([0]?||[1-9]\d{0,2}(\d{3})*|([1-9]\d*))(\.\d{0,2})?$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  handleMateriaPrimaTextoChange = (e) => {
    this.cleanErrorsValidation("materia_prima_texto");
    this.setState({
      materia_prima_texto: e.target.value.toUpperCase(),
    });
  };

  handleProductoTipoAlimentoChange = (e) => {
    this.setState({
      tipo_especie: this.initialState.tipo_especie,
      tipo_categoria_especie: this.initialState.tipo_categoria_especie,
      razon_social: this.initialState.razon_social,
      establecimiento_id: this.initialState.establecimiento_id,
      cat_categorias: this.initialState.cat_categorias,
    });
    if (this.state.producto_fabricante_registrado) {
      this.getEstablecimientoFabricanteProducto(e.id);
      this.cleanErrorsValidation("producto_tipo_alimento");
      this.cleanErrorsValidation("razon_social");
      this.cleanErrorsValidation("no_registro");
      this.cleanErrorsValidation("forma_farmaceutica_id");
      this.getCatProductoEspecieFabricante(e.id);
      this.setState({
        producto_tipo_alimento: e.id,
        no_registro: e.no_registro,
        producto_tipo_alimento_texto: e.nombre_comercial,
        forma_farmaceutica_id: e.forma_farmaceutica_id,
        forma_farmaceutica_texto: e.forma_farmaceutica_te.toUpperCase(),
      });
    } else {
      this.cleanErrorsValidation("producto_tipo_alimento_texto");
      this.setState({
        producto_tipo_alimento_texto: e.target.value.toUpperCase(),
      });
    }
  };

  handleMateriaPrimaChange = (e) => {
    this.cleanErrorsValidation("materia_prima");
    this.setState({ materia_prima: e });
  };

  handleVolumenSemanalChange = (e) => {
    if (this.checkPositiveFloats(e.target.value)) {
      this.setState({ volumen_semanal: e.target.value });
    }
  };

  handleVolumenMensualChange = (e) => {
    if (this.checkPositiveFloats(e.target.value)) {
      this.setState({ volumen_mensual: e.target.value });
    }
  };

  handlePorcentajeExportacionChange = (e) => {
    if (this.checkPositiveFloats(e.target.value)) {
      this.setState({ porc_exp_nica: e.target.value });
    }
  };

  handleTipoSubproductoChange = (e) => {
    this.cleanErrorsValidation("tipo_subproducto");
    this.setState({ tipo_subproducto: e });
  };

  toogleSRonlyInput = (registrado) => {
    if (!registrado) {
      document.getElementById("direccion").removeAttribute("readonly");
      document.getElementById("latitud").removeAttribute("readonly");
      document.getElementById("longitud").removeAttribute("readonly");

      let campos_obligatorios = document.querySelectorAll(".campo-obligatorio");
      campos_obligatorios.forEach((el) => {
        el.style.display = "none";
      });
    } else {
      document.getElementById("direccion").setAttribute("readonly", true);
      document.getElementById("latitud").setAttribute("readonly", true);
      document.getElementById("longitud").setAttribute("readonly", true);

      let campos_obligatorios = document.querySelectorAll(".campo-obligatorio");
      campos_obligatorios.forEach((el) => {
        el.style.display = "inline";
      });
    }

    this.setState({
      licencia_establecimiento: this.initialState.tipo_establecimiento,
      direccion: this.initialState.direccion,
      latitud: this.initialState.latitud,
      longitud: this.initialState.longitud,
      folio_establecimiento: this.initialState.folio_establecimiento,
      departamento_id: this.initialState.departamento_id,
      municipio_id: this.initialState.municipio_id,
      pais: this.initialState.pais,
      correo_electronico: this.initialState.correo_electronico,
      telefono: this.initialState.telefono,
      nombreDepartamento: this.initialState.nombreDepartamento,
      nombreMunicipio: this.initialState.nombreMunicipio,
      actividad_id: this.initialState.actividad_id,
      razon_social: this.initialState.razon_social,
      establecimiento_id: this.initialState.establecimiento_id,
      tipo_establecimiento: this.initialState.tipo_establecimiento,
      representantes_legales: this.initialState.representantes_legales,
      regentes: this.initialState.regentes,
    });
  };

  handleProductoFabricanteRegistradoChange = (e) => {
    this.setState({
      producto_fabricante_registrado: e.target.checked,
      producto_tipo_alimento: this.initialState.producto_tipo_alimento,
      producto_tipo_alimento_texto:
        this.initialState.producto_tipo_alimento_texto,
      no_registro: this.initialState.no_registro,
      forma_farmaceutica_texto: this.initialState.forma_farmaceutica_texto,
      forma_farmaceutica: this.initialState.forma_farmaceutica,
      forma_farmaceutica_id: this.initialState.forma_farmaceutica_id,
      tipo_especie: this.initialState.tipo_especie,
      cat_especies_productos_dosis:
        this.initialState.cat_especies_productos_dosis,
      razon_social: this.initialState.razon_social,
      establecimiento_id: this.initialState.establecimiento_id,
      cat_categoria: this.initialState.cat_categoria,
      tipo_categoria_especie: this.initialState.tipo_categoria_especie,
      cat_categorias: this.initialState.cat_categorias,
      representantes_legales: this.initialState.representantes_legales,
      regentes: this.initialState.regentes,
    });

    if (!e.target.checked) {
      document.getElementById("razon_social").removeAttribute("readonly");
    }

    this.cleanErrorsValidation("forma_farmaceutica_id");
    this.cleanErrorsValidation("tipo_especie");
    this.cleanErrorsValidation("no_lote");
    this.cleanErrorsValidation("vol_peso");
    this.cleanErrorsValidation("razon_social");
    this.cleanErrorsValidation("razon_social_muestra");
    this.cleanErrorsValidation("departamento_id");
    this.cleanErrorsValidation("municipio_id");
    this.cleanErrorsValidation("inspectores");
    this.cleanErrorsValidation("tipo_motivo_remision");
    this.cleanErrorsValidation("nombre_recibe_laboratorio");
    this.cleanErrorsValidation("nombre_representante");
    this.cleanErrorsValidation("tipo_muestra");
  };

  handleLocacionAnalisisNacional = (e) => {
    this.setState({
      departamento_id: this.initialState.departamento_id,
      municipio_id: this.initialState.municipio_id,
      nombreMunicipio: this.initialState.nombreMunicipio,
      nombreDepartamento: this.initialState.nombreDepartamento,
      pais_id: this.initialState.pais_id,
      nombrePais: this.initialState.nombrePais,
    });

    if (!e.target.checked) {
      this.setState({
        locacion_analisis_nacional: false,
      });
    } else {
      this.setState({
        locacion_analisis_nacional:
          this.initialState.locacion_analisis_nacional,
      });
    }

    this.cleanErrorsValidation("departamento_id");
    this.cleanErrorsValidation("municipio_id");
  };

  handleFormaFarmaceuticaChange = (e) => {
    this.cleanErrorsValidation("forma_farmaceutica_id");

    if (!this.state.producto_fabricante_registrado || this.state.tipo_muestra) {
      e
        ? this.setState({
            forma_farmaceutica_texto: e.descripcion,
            forma_farmaceutica_id: e.id,
            forma_farmaceutica: e,
          })
        : this.setState({
            forma_farmaceutica_texto:
              this.initialState.forma_farmaceutica_texto,
            forma_farmaceutica_id: this.initialState.forma_farmaceutica_id,
            forma_farmaceutica: this.initialState.forma_farmaceutica_id,
          });
    }
  };

  handleEstablecimientoRegistradoChange = (e) => {
    this.setState({
      establecimiento_registrado: e.target.checked,
      pais_id: this.initialState.pais_id,
      nombrePais: this.initialState.nombrePais,
      municipio_id: this.initialState.municipio_id,
      departamento_id: this.initialState.departamento_id,
      // cat_productos: this.initialState.cat_productos,
      cat_presentacion_producto: this.initialState.cat_presentacion_producto,
      producto: this.initialState.producto,
      presentacion_producto: this.initialState.presentacion_producto,
      cantidad_producto: this.initialState.cantidad_producto,
      motivo_acto: this.initialState.motivo_acto,
      cat_actividades: this.initialState.cat_actividades,
      inspectores: this.initialState.inspectores,
      destino_produccion: this.initialState.destino_produccion,
      materia_prima: this.initialState.materia_prima,
      tipo_subproducto: this.initialState.tipo_subproducto,
      tipo_especie: this.initialState.tipo_especie,
      tipo_inspeccion: this.initialState.tipo_inspeccion,
      cargo_receptor: this.initialState.cargo_receptor,
      nombre_receptor: this.initialState.nombre_receptor,
      porc_exp_nica: this.initialState.porc_exp_nica,
      lugar: this.initialState.lugar,
      volumen_mensual: this.initialState.volumen_mensual,
      volumen_semanal: this.initialState.volumen_semanal,
      productos_detalle_acta: this.initialState.productos_detalle_acta,
      hora_atencion_inicio: this.initialState.hora_atencion_inicio,
      hora_atencion_final: this.initialState.hora_atencion_final,
      establecimiento_sancionado: this.initialState.establecimiento_sancionado,
      displayAcc: this.initialState.displayAcc,
      loadedObsInfo: this.initialState.loadedObsInfo,
      representantes_legales: this.initialState.representantes_legales,
      regentes: this.initialState.regentes,
      municipios: this.initialState.municipios,
    });

    this.toogleSRonlyInput(e.target.checked);
    this.cleanErrorsValidation("actividad_id");
    this.cleanErrorsValidation("telefono");
    this.cleanErrorsValidation("correo_electronico");
    this.cleanErrorsValidation("inspectores");
    this.cleanErrorsValidation("propietario");
    this.cleanErrorsValidation("nombre_receptor");
    this.cleanErrorsValidation("cargo_receptor");
    this.cleanErrorsValidation("lugar");
    this.cleanErrorsValidation("tipo_inspeccion");
    this.cleanErrorsValidation("direccion");
    this.cleanErrorsValidation("latitud");
    this.cleanErrorsValidation("longitud");
    this.cleanErrorsValidation("folio_establecimiento");
    this.cleanErrorsValidation("tipo_establecimiento");
    this.cleanErrorsValidation("licencia_establecimiento");
    this.cleanErrorsValidation("regente");
    this.cleanErrorsValidation("regente_presente");
    this.cleanErrorsValidation("correo_electronico_regente");
    this.cleanErrorsValidation("nombrePais");
    this.cleanErrorsValidation("departamento_id");
    this.cleanErrorsValidation("municipio_id");
    this.cleanErrorsValidation("no_licencia_disaan");
    this.cleanErrorsValidation("num_regente");
    this.cleanErrorsValidation("fecha_vencimiento");
    this.cleanErrorsValidation("hora_atencion_final");
    this.cleanErrorsValidation("hora_atencion_inicio");
    this.cleanErrorsValidation("tipo_especie");
    this.cleanErrorsValidation("destino_produccion");
    this.cleanErrorsValidation("materia_prima");
    this.cleanErrorsValidation("tipo_subproducto");
    this.cleanErrorsValidation("productos_detalle_acta");

    if (e.target.checked === false) {
      if (
        ["1", "2", "3", "11", "12", "13"].includes(this.state.tipo_encuesta)
      ) {
        if (this.state.tipo_encuesta !== "13") {
          this.resetVerifications();
        }
        if (this.state.tipo_encuesta === "13") {
          //llamamos fn para limpiar las ultima observaciones en caso de que haya
          this.limpiarUltimasObs();
          this.limpiarLastObsChecked();
        }
        this.getCatTipoEstablecimiento();
        this.setState({
          observaciones_anteriores: this.initialState.observaciones_anteriores,
          recomendaciones_anteriores:
            this.initialState.recomendaciones_anteriores,
          ultima_fecha_inspeccion: this.initialState.ultima_fecha_inspeccion,
        });
      }
    }

    if (["11", "12", "13"].includes(this.state.tipo_encuesta)) {
      document.getElementById("actividad_id").removeAttribute("disabled");
    }

    if (this.state.tipo_encuesta === "13") {
      this.setState({
        verificaciones: this.initialState.verificaciones,
        displayAcc: this.initialState.displayAcc,
      });
    }
  };
  

  handleRegProductoManualChange = (e) => {
    this.cleanErrorsValidation("productos_detalle_acta");
    this.setState({
      producto: this.initialState.producto,
      presentacion_producto: this.initialState.presentacion_producto,
      cantidad_producto: this.initialState.cantidad_producto,
      motivo_acto: this.initialState.motivo_acto,
      reg_producto_manual: e.target.checked,
      // productos_detalle_acta: this.initialState.productos_detalle_acta,
    });
  };

  handleDepartamentoChange = (e) => {
    this.cleanErrorsValidation("departamento_id");

    // se filtra locations municipioa por el estado_id
    let result = this.state.locations.municipios.filter(
      (municipio) => municipio.estado_id === e.target.value
    );

    this.setState({
      departamento_id: e.target.value,
      nombreDepartamento: e.target.options[e.target.selectedIndex].text,
      municipios: result,
      municipio_id: this.initialState.municipio_id,
      nombreMunicipio: this.initialState.nombreMunicipio,
    });
  };

  handleMunicipioChange = (e) => {
    this.cleanErrorsValidation("municipio_id");
    this.setState({
      municipio_id: e.target.value,
      nombreMunicipio: e.target.options[e.target.selectedIndex].text,
    });
  };

  handleTipoEstablecimientoChange = (e) => {
    this.cleanErrorsValidation("tipo_establecimiento");

    this.setState({
      tipo_establecimiento: e.target.value,
      actividad_id: this.initialState.actividad_id,
      municipio_id: this.initialState.municipio_id,
      departamento_id: this.initialState.departamento_id,
      nombrePais: this.initialState.nombrePais,
      nombreMunicipio: this.initialState.nombreMunicipio,
      municipios: this.initialState.municipios,
      pais_id: this.initialState.pais_id,
      displayAcc: this.initialState.displayAcc,
      loadedObsInfo: this.initialState.loadedObsInfo,
    });

    this.getCatTipoActividades(e.target.value);
  };

  setHoraFinEncuesta = () => {
    this.setState({
      hora_fin: new Date().getHours() + ":" + new Date().getMinutes(),
    });
  };

  handleProductoActaChange = (e, element = null) => {
    this.cleanErrorsValidation("productos_detalle_acta");
    let prodDA = { ...this.state.producto_detalle_acta };

    if (element === "productos_detalle_acta") {
      if (
        // this.state.establecimiento_registrado &&
        !this.state.reg_producto_manual
      ) {
        prodDA["producto_id"] = e["id"];
        prodDA["nombre_comercial"] = e["nombre_comercial"];
        this.setState({
          producto: e,
          presentacion_producto: this.initialState.presentacion_producto,
          cantidad_producto: this.initialState.cantidad_producto,
          motivo_acto: this.initialState.motivo_acto,
        });
        if (e["id"] !== "") {
          this.getProductPresentation(e["id"]);
        }
      } else {
        prodDA["producto_id"] = null;
        prodDA["nombre_comercial"] = e.target.value.toUpperCase();
        this.setState({
          producto: e.target.value.toUpperCase(),
          // presentacion_producto: this.initialState.presentacion_producto,
          // cantidad_producto: this.initialState.cantidad_producto,
          // motivo_acto: this.initialState.motivo_acto,
        });
      }
    }

    if (element === "presentacionProducto") {
      if (
        // this.state.establecimiento_registrado &&
        !this.state.reg_producto_manual
      ) {
        prodDA["presentacion_id"] = e["id"];
        if (!e["empaque"]) {
          prodDA["presentacion"] = `${e["cantidad"]} ${e["unidad_medida"]}`;
          prodDA["notable_type"] = "App\\RelVisitaPresentacion";
        } else {
          prodDA["presentacion"] = `${e["empaque"].toUpperCase()} (${
            e["cantidad"]
          }${e["unidad_medida"]})`;
          prodDA["notable_type"] = "App\\RelVisitaEmpaque";
        }

        this.setState({ presentacion_producto: e });
      } else {
        prodDA["presentacion_id"] = null;
        prodDA["presentacion"] = e.target.value.toUpperCase();
        prodDA["notable_type"] = null;
        this.setState({ presentacion_producto: e.target.value.toUpperCase() });
      }
    }

    if (element === "cantidadProducto") {
      let regex = /^[1-9]\d*$/;

      if (e.target.value === "" || regex.test(e.target.value)) {
        prodDA["cantidad"] = e.target.value;
        this.setState({ cantidad_producto: e.target.value });
      }
    }

    if (element === "motivo_acto") {
      prodDA["motivo_acto"] = e.target.value.toUpperCase();
      this.setState({ motivo_acto: e.target.value.toUpperCase() });
    }

    this.setState({ producto_detalle_acta: prodDA });
  };

  handleProductoActaDestruccionChange = (e) => {
    this.cleanErrorsValidation("productos_detalle_acta");
    let prodDAD = { ...this.state.producto_detalle_acta_destruccion };

    if (e.target.id === "productos_detalle_acta") {
      prodDAD["num_acta_decomiso"] = e.target.value;
      this.setState({ num_acta_decomiso: e.target.value });
    }

    if (e.target.id === "motivo_acto") {
      prodDAD["motivo_acto"] = e.target.value.toUpperCase();
      this.setState({ motivo_acto: e.target.value.toUpperCase() });
    }
    this.setState({ producto_detalle_acta_destruccion: prodDAD });
  };

  handleAnalisisSolicitadoChange = (e) => {
    let elemento = e.target.id.split("-"),
      analisis_resultado = this.state.analisis_resultado;
    let especificacionDOM = document.getElementById(
      `analisis_producto_input_otro-${elemento[1]}`
    );
    let obj = this.getAnalisisOtrosObjectItem(elemento[1]);

    if (elemento[0] === "analisis_producto_input") {
      let objectItemID = this.getAnalisisObjectItem(elemento[1]);

      analisis_resultado[objectItemID]["valor"] = e.target.value.toUpperCase();
    }

    if (elemento[0] === "analisis_producto_nombre_otro") {
      this.verificarNombresAnalisis(e.target.value.toUpperCase(), e.target.id);
      if (!obj) {
        analisis_resultado.push({
          analisis_solicitado_id: null,
          otros: e.target.value.toUpperCase(),
          valor: null,
          otro_id: elemento[1],
        });
      } else {
        analisis_resultado[obj]["otros"] = e.target.value.toUpperCase();
      }

      if (e.target.value !== null || e.target.value !== "") {
        especificacionDOM.removeAttribute("readonly");
      }
    }

    if (elemento[0] === "analisis_producto_input_otro") {
      analisis_resultado[obj]["valor"] = e.target.value.toUpperCase();
    }

    this.setState({ analisis_resultado: analisis_resultado });
  };

  handleAnalisisSolicitadoCBChange = (e) => {
    let id = e.target.id.split("-")[1],
      analisis_resultado = this.state.analisis_resultado;
    let input = document.getElementById(`analisis_producto_input-${id}`);

    if (e.target.checked) {
      input.removeAttribute("readonly");
      input.value = null;
      analisis_resultado.push({
        analisis_solicitado_id: id,
        otros: null,
        valor: null,
        otro_id: null,
      });
    } else {
      input.setAttribute("readonly", true);
      input.value = null;
      let objItemID = this.getAnalisisObjectItem(id);

      if (analisis_resultado[objItemID]) {
        delete analisis_resultado[objItemID];
      }
    }

    analisis_resultado = this.resetAnalisisObjectIndexes();

    this.setState({ analisis_resultado: analisis_resultado });
  };

  getAnalisisObjectItem = (id) => {
    return Object.keys(this.state.analisis_resultado).find(
      (key) => this.state.analisis_resultado[key].analisis_solicitado_id === id
    );
  };

  getAnalisisOtrosObjectItem = (id) => {
    return Object.keys(this.state.analisis_resultado).find(
      (key) => this.state.analisis_resultado[key].otro_id === id
    );
  };

  resetAnalisisObjectIndexes = () => {
    return this.state.analisis_resultado.filter(function (e) {
      return e != null;
    });
  };

  handleFechaVencimientoChange = (e) => {
    this.setState({ fecha_vencimiento: e.target.value });
  };

  verificarNombresAnalisis = (analisis, elemento_id) => {
    let comparador1 = false,
      comparador2 = false,
      nombres_analisis_duplicados = this.state.nombres_analisis_duplicados;

    // removemos clase is invalid
    // document.getElementById(elemento_id).classList.remove("is-invalid");

    comparador1 = this.state.cat_analisis_solicitado.some(
      (nombre) =>
        nombre.descripcion.toUpperCase() === analisis && analisis !== ""
    );

    comparador2 = this.state.analisis_resultado.some((nombre) => {
      if (nombre.otros) {
        return nombre.otros.toUpperCase() === analisis && analisis !== "";
      }
      return false;
    });

    if (comparador1 || comparador2) {
      // document.getElementById(elemento_id).classList.add("is-invalid");
      nombres_analisis_duplicados[elemento_id] = analisis;
    }

    if (
      !comparador1 &&
      !comparador2 &&
      nombres_analisis_duplicados[elemento_id]
    ) {
      delete nombres_analisis_duplicados[elemento_id];
    }

    this.setState({
      nombres_analisis_duplicados: nombres_analisis_duplicados,
    });
  };

  handlePropietarioChange = (e) => {
    this.cleanErrorsValidation("propietario");
    this.setState({ propietario: e.target.value.toUpperCase() });
  };

  handleNumRegenteChange = (e) => {
    this.setState({ num_regente: e.target.value });
  };
  handleRegentePresenteChange = (e) => {
    this.cleanErrorsValidation("regente_presente");
    this.setState({ regente_presente: e.target.value });
  };

  handleRegenteVigenteChange = (e) => {
    this.cleanErrorsValidation("regente_vigente");
    this.setState({ regente_vigente: e.target.value });
  };

  handleHoraInicioChange = (e) => {
    this.cleanErrorsValidation("hora_atencion_inicio");
    this.setState({ hora_atencion_inicio: e.target.value });
  };

  handleHoraChange = (e) => {
    this.setState({ hora: e.target.value });
  };

  handleHoraFinalChange = (e) => {
    this.cleanErrorsValidation("hora_atencion_final");
    this.setState({ hora_atencion_final: e.target.value });
  };

  handleInspectoresChange = (e) => {
    this.cleanErrorsValidation("inspectores");
    this.setState({ inspectores: e });
  };

  handleNombreRepresentanteChange = (e) => {
    this.cleanErrorsValidation("nombre_representante");
    this.setState({ nombre_representante: e.target.value.toUpperCase() });
  };

  handleNombreRecibeLaboratorioChange = (e) => {
    this.cleanErrorsValidation("nombre_recibe_laboratorio");
    this.setState({ nombre_recibe_laboratorio: e.target.value.toUpperCase() });
  };

  handleLugarChange = (e) => {
    this.cleanErrorsValidation("lugar");
    this.setState({ lugar: e.target.value.toUpperCase() });
  };

  handleCorreoElectronicoRegenteChange = (e) => {
    this.cleanErrorsValidation("correo_electronico_regente");
    this.setState({ correo_electronico_regente: e.target.value });
  };

  handleFolioEstablecimientoChange = (e) => {
    this.cleanErrorsValidation("folio_establecimiento");
    if (this.state.establecimiento_registrado) {
      this.setState({
        folio_establecimiento: e,
        licencia_establecimiento: this.initialState.licencia_establecimiento,
        actividad_id: this.initialState.actividad_id,
      });
    } else {
      this.setState({
        folio_establecimiento: e.target.value,
      });
    }
  };

  handleLicenciaEstablecimientoChange = (e) => {
    this.cleanErrorsValidation("licencia_establecimiento");
    if (!this.state.establecimiento_registrado) {
      this.setState({ licencia_establecimiento: e.target.value });
    }
  };

  handleSancionEstablecimientoCBChange = (e) => {
    this.setState({
      establecimiento_sancionado: e.target.checked,
    });
  };

  handlePaisChange = (e) => {
    this.cleanErrorsValidation("nombrePais");
    if (
      !this.state.establecimiento_registrado ||
      ["8", "9", "10"].includes(this.state.tipo_encuesta)
    ) {
      this.setState({
        nombrePais: e.target.options[e.target.selectedIndex].text,
        pais_id: e.target.value,
      });
    }
  };

  handleActividadChange = (e) => {
    this.cleanErrorsValidation("actividad_id");
    this.cleanErrorsValidation("licencia_establecimiento");

    this.setState({
      actividad_id: e.target.value,
      observaciones_anteriores: this.initialState.observaciones_anteriores,
      recomendaciones_anteriores: this.initialState.recomendaciones_anteriores,
      ultima_fecha_inspeccion: this.initialState.ultima_fecha_inspeccion,
      loadedObsInfo: this.initialState.loadedObsInfo,
    });

    if (this.state.establecimiento_registrado) {
      this.setState({
        licencia_establecimiento: e.target[e.target.selectedIndex].getAttribute(
          "data-folio-licencia"
        ),
      });
      if (!["4", "5", "6", "7", "13"].includes(this.state.tipo_encuesta)) {
        this.getLastVerificationsInfo(e.target.value);
      }

      this.getUltimaInspeccionInfo(
        this.state.establecimiento_id,
        e.target.value,
        this.state.tipo_encuesta
      );
    }

    if (this.state.tipo_encuesta === "13") {
      //llamamos fn para limpiar las ultima observaciones en caso de que haya
      this.limpiarUltimasObs();
      this.limpiarLastObsChecked();

      if (this.state.establecimiento_registrado) {
        document.getElementById("actividad_id").setAttribute("disabled", true);
      } else {
        document.getElementById("actividad_id").removeAttribute("disabled");
      }

      e.target.value
        ? this.setState({
            displayAcc: true,
            verificaciones: this.initialState.verificaciones,
          })
        : this.setState({
            displayAcc: this.initialState.displayAcc,
            verificaciones: this.initialState.verificaciones,
          });
    }
  };

  limpiarActividadID = () => {
    if (this.state.tipo_encuesta !== "13") {
      this.resetVerifications();
    }
    if (this.state.tipo_encuesta === "13") {
      //llamamos fn para limpiar las ultima observaciones en caso de que haya
      this.limpiarUltimasObs();
      this.limpiarLastObsChecked();
    }
    this.setState({
      actividad_id: this.initialState.actividad_id,
      verificaciones: this.initialState.verificaciones,
      licencia_establecimiento: this.initialState.licencia_establecimiento,
      displayAcc: this.initialState.displayAcc,
      observaciones_anteriores: this.initialState.observaciones_anteriores,
      recomendaciones_anteriores: this.initialState.recomendaciones_anteriores,
      ultima_fecha_inspeccion: this.initialState.ultima_fecha_inspeccion,
    });

    document.getElementById("actividad_id").removeAttribute("disabled");
  };

  limpiarUltimasObs = () => {
    let vd = this.state.variables_dinamicas;
    for (const key in vd) {
      vd[key].forEach((v) => {
        if (v.hasOwnProperty("ultima_observacion")) {
          delete v.ultima_observacion;
        }
      });
    }

    this.setState({ variables_dinamicas: vd });
  };

  limpiarLastObsChecked = () => {
    let quizzes = this.state.quizzes;
    quizzes.forEach((quizz) => {
      quizz.last_obs_checked = false;
    });

    this.setState({ quizzes: quizzes });
  };

  getUltimaInspeccionInfo = (
    establecimiento_id,
    actividad_id,
    tipo_encuesta
  ) => {
    Api.fetch(
      "app/getUltimaInspeccionInfo?establecimiento_id=" +
        establecimiento_id +
        "&actividad_id=" +
        actividad_id +
        "&tipo_encuesta=" +
        tipo_encuesta
    ).then((data) => {
      if (data.length > 0) {
        this.setState({
          ultima_fecha_inspeccion: data[0].fecha,
          observaciones_anteriores: data[0].observaciones,
          recomendaciones_anteriores: data[0].recomendaciones,
        });
      }
    });
  };

  getInspectors = () => {
    Api.fetch("app/getInspectors").then((data) => {
      if (data) {
        this.setState({ cat_inspectores: data });
      }
    });
  };

  getCategoriaEspecies = (ids) => {
    let url = "";
    Api.loading(true);
    this.state.producto_fabricante_registrado
      ? (url =
          "app/getCategoriaEspecies?especiesArr=" +
          ids +
          "&producto_id=" +
          this.state.producto_tipo_alimento)
      : (url = "app/getCategoriaEspecies?especiesArr=" + ids);
    Api.fetch(url)
      .then((data) => {
        if (data) {
          this.setState({ cat_categorias: data });

          // actualizamos las catergorias seleccionados en caso de que haya, para quitar las opciones de especies que se quitaron
          if (this.state.tipo_categoria_especie) {
            let coincidencias = this.state.tipo_categoria_especie.filter((a) =>
              data.some((b) => a.id === b.id)
            );

            this.setState({ tipo_categoria_especie: coincidencias });
          }
        }
      })
      .then((res) => Api.loading(false));
  };

  getEstablecimientoFabricanteProducto = (producto_id) => {
    Api.fetch(
      "app/getEstablecimientoFabricanteProducto?producto_id=" + producto_id
    ).then((data) => {
      if (Object.entries(data).length > 0) {
        // this.getRepresentantesLegales(data.id);
        // this.getRegentes(data.id);
        this.setState({
          razon_social: data.razon_social,
          establecimiento_id: data.id,
          establecimiento_fabricante_registrado: true,
        });
        document.getElementById("razon_social").setAttribute("readonly", true);
      } else {
        this.setState({
          establecimiento_fabricante_registrado: false,
        });
        document.getElementById("razon_social").removeAttribute("readonly");
      }
    });
  };

  handleEstablecimientoFabricanteRegistrado = (e) => {
    this.cleanErrorsValidation("razon_social");
    if (e.target.checked) {
      if (
        Object.keys(this.state.cat_establecimientos_fabricante_alimento)
          .length === 0
      ) {
        this.getAllEstablecimientosFabricanteAlimento();
      }
    }

    this.setState({
      establecimiento_fabricante_registrado: e.target.checked,
      establecimiento_id: this.initialState.establecimiento_id,
      razon_social: this.initialState.razon_social,
    });
  };

  handleEstablecimientoMuestraRegistrado = (e) => {
    this.cleanErrorsValidation("razon_social_muestra");
    this.setState({
      razon_social_muestra: this.initialState.razon_social_muestra,
      establecimiento_id_muestra: this.initialState.establecimiento_id_muestra,
      correo_electronico: this.initialState.correo_electronico,
      pais_id: this.initialState.pais_id,
      // nombrePais: this.initialState.nombrePais,
      latitud: this.initialState.latitud,
      longitud: this.initialState.longitud,
      telefono: this.initialState.telefono,
      folio_establecimiento: this.initialState.folio_establecimiento,
      // departamento_id: this.initialState.departamento_id,
      // municipio_id: this.initialState.municipio_id,
      actividad_id: this.initialState.actividad_id,
      direccion: this.initialState.direccion,
      cat_actividades: this.initialState.cat_actividades,
      representantes_legales: this.initialState.representantes_legales,
      regentes: this.initialState.regentes,
      departamento_id: this.initialState.departamento_id,
      municipio_id: this.initialState.departamento_id,
      pais_texto: this.initialState.nombrePais,
    });

    if (e.target.checked) {
      this.setState({
        establecimiento_muestra_registrado:
          this.initialState.establecimiento_muestra_registrado,
      });
    } else {
      this.setState({
        establecimiento_muestra_registrado: false,
      });
    }

    // this.setState({
    //   establecimiento_fabricante_registrado: e.target.checked,
    //   establecimiento_id: this.initialState.establecimiento_id,
    //   razon_social: this.initialState.razon_social,
    // });
  };

  getCatProductoEspecieFabricante = (producto_id) => {
    Api.loading(true);
    Api.fetch("app/getCatProductoEspecieFabricante?producto_id=" + producto_id)
      .then((data) => {
        if (data) {
          for (const key in data) {
            data[key]["isDisabled"] = false;
          }
          this.setState({ cat_especies_productos_dosis: data });
        }
      })
      .then((res) => Api.loading(false));
  };

  getCatTipoEstablecimiento = () => {
    Api.loading(true);
    Api.fetch(
      "app/getCatTipoEstablecimiento?tipo_encuesta=" + this.state.tipo_encuesta
    )
      .then((data) => {
        if (data) {
          this.setState({ cat_tipo_establecimiento: data });
        }
      })
      .then((data) => {
        Api.loading(false);
      });
  };

  getCatAnalisisResultado = (encuesta_id) => {
    let total_analisis_solicitado = this.state.total_analisis_solicitado;
    Api.fetch("app/getCatAnalisisResultado?encuesta_id=" + encuesta_id).then(
      (data) => {
        if (data) {
          let arr = [],
            sortedArr = [];

          data.forEach((item) => arr.push(item));

          sortedArr = arr.sort(function (a, b) {
            return parseFloat(a.id) - parseFloat(b.id);
          });

          total_analisis_solicitado = parseInt(
            sortedArr[sortedArr.length - 1]["id"]
          );

          this.setState({
            cat_analisis_solicitado: sortedArr,
            total_analisis_solicitado: total_analisis_solicitado,
          });
        }
      }
    );
  };

  getCatTipoActividades = (tipo_establecimiento) => {
    Api.loading(true);
    if (["1", "2", "3", "11", "12", "13"].includes(this.state.tipo_encuesta)) {
      Api.fetch(
        "app/getCatTipoActividades?tipo_establecimiento=" +
          tipo_establecimiento +
          "&tipo_encuesta=" +
          this.state.tipo_encuesta
      )
        .then((data) => {
          if (data) {
            this.setState({ cat_actividades: data });
          }
        })
        .then((data) => {
          Api.loading(false);
        });
    } else {
      Api.fetch(
        "app/getCatTipoEstablecimientoActividades?tipo_establecimiento=" +
          tipo_establecimiento
      )
        .then((data) => {
          if (data) {
            this.setState({ cat_actividades: data });
          }
        })
        .then((data) => {
          Api.loading(false);
        });
    }
  };

  getLastVerificationsInfo = (actividad_id) => {
    Api.loading(true);
    Api.fetch(
      "app/getLastVerificationsInfo?establecimiento_id=" +
        this.state.establecimiento_id +
        "&tipo_encuesta=" +
        this.state.tipo_encuesta +
        "&actividad_id=" +
        actividad_id
    )
      .then((data) => {
        let contador = 0;
        if (data) {
          if (this.state.tipo_encuesta !== "13") {
            let encuesta = this.state.quizzes;
            encuesta.forEach((q) =>
              q.verificaciones.forEach((e) => {
                if (data.length > 0) {
                  e["ultima_observacion"] = data[contador++]["observacion"];
                } else {
                  e["ultima_observacion"] = null;
                }
              })
            );
            this.setState({ quizz: encuesta });
          }
        }
      })
      .then((data) => Api.loading(false));
  };

  maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  submitForm = (visitaData) => {
    Api.loading(true);
    Api.fetch("app/storeQuizz", visitaData, "POST").then((data) => {
      if (data.errors) {
        this.handleValidations(data.errors);
        Api.loading(false);
        this.fireSwal(
          "¡Verifique que los datos esten correctamente completados!",
          "warning"
        );
        return false;
      } else {
        Api.loading(false);
        this.setState({ modalState: false });
        this.resetStates();
        Swal.fire({
          icon: "success",
          title: "¡La encuesta ha sido guardada correctamente!",
          timer: 3000,
        }).then(() => {
          window.location.href = "/visitas";
        });
      }
    });
  };

  resetStates = () => {
    this.setState({ ...this.initialState });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    Swal.fire({
      icon: "question",
      title: "¿Completar formulario?",
      text: "¡Asegúrese que los datos estén completados correctamente!",
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      showCancelButton: false,
      confirmButtonText: `Continuar`,
      denyButtonText: `Regresar`,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setHoraFinEncuesta();

        if (["8", "9", "10"].includes(this.state.tipo_encuesta)) {
          this.setVisitaTipoMuestra();
        }
        let visitaData = {
          ...this.state,
          hora_fin: new Date().getHours() + ":" + new Date().getMinutes(),
        };

        delete visitaData.modalState;
        delete visitaData.cat_actividades;
        delete visitaData.cat_inspectores;
        delete visitaData.info_encuesta;
        delete visitaData.quizzes;
        delete visitaData.cat_especies;
        delete visitaData.cat_materia_prima;
        delete visitaData.cat_tipo_inspeccion;
        delete visitaData.cat_tipo_produccion;
        delete visitaData.cat_tipo_subproducto;
        delete visitaData.cat_productos;
        delete visitaData.establecimientos;
        delete visitaData.locations;
        delete visitaData.cat_motivo_remision;
        delete visitaData.cat_paises;
        delete visitaData.cat_presentacion_producto;
        delete visitaData.cat_especies_productos_dosis;
        delete visitaData.cat_productos_tipo_alimento;
        delete visitaData.cat_tipo_establecimiento;
        delete visitaData.cat_um;
        delete visitaData.cat_um;
        delete visitaData.cat_categorias;
        delete visitaData.cat_establecimientos_alimento;
        delete visitaData.cat_establecimientos_fabricante_alimento;
        delete visitaData.cat_analisis_producto;
        delete visitaData.cat_analisis_solicitado;
        delete visitaData.cat_forma_farmaceutica;
        delete visitaData.cat_tipo_muestra;

        if (
          this.state.tipo_encuesta === "9" ||
          this.state.tipo_encuesta === "10"
        ) {
          if (Object.keys(this.state.analisis_resultado).length === 0) {
            this.fireSwal(
              "Debes ingresar al menos un análisis de producto.",
              "warning"
            );
          } else if (
            Object.keys(this.state.nombres_analisis_duplicados).length > 0
          ) {
            this.fireSwal(
              "¡Verifica que los nombres de análisis solcitados no se encuentren repetidos!",
              "warning"
            );
          } else {
            this.submitForm(visitaData);
          }
        } else {
          this.submitForm(visitaData);
        }
      }
    });
  };


  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">Inicio</li>
          <li className="breadcrumb-item active">Encuestas</li>
        </ol>
        <h1 className="page-header">Fiscalización</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>

        <Modal
          isOpen={this.state.modalState}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader toggle={this.handleFormCloseBtn} className="text-center">
            {this.state.info_encuesta.descripcion}
          </ModalHeader>
          <ModalBody>
            <form id="quizz-form" onSubmit={this.handleSubmit}>
              {this.state.tipo_encuesta === "1" ||
              this.state.tipo_encuesta === "2" ||
              this.state.tipo_encuesta === "3" ? (
                <VisitaGrupo1
                  key={this.state.tipo_encuesta}
                  component={this}
                  state={this.state}
                />
              ) : this.state.tipo_encuesta === "4" ||
                this.state.tipo_encuesta === "5" ||
                this.state.tipo_encuesta === "6" ||
                this.state.tipo_encuesta === "7" ? (
                <VisitaGrupo2
                  key={this.state.tipo_encuesta}
                  state={this.state}
                  component={this}
                />
              ) : this.state.tipo_encuesta === "8" ||
                this.state.tipo_encuesta === "9" ||
                this.state.tipo_encuesta === "10" ? (
                <VisitaGrupo3
                  key={this.state.tipo_encuesta}
                  state={this.state}
                  component={this}
                />
              ) : this.state.tipo_encuesta === "11" ||
                this.state.tipo_encuesta === "12" ||
                this.state.tipo_encuesta === "13" ? (
                <VisitaGrupo4
                  key={this.state.tipo_encuesta}
                  component={this}
                  state={this.state}
                />
              ) : null}
            </form>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Quizzes;
